import config from '../config';

import { startOfDay, endOfDay, subDays, addDays } from 'date-fns';

export async function fetchMeteringHistorical(backendFetch, siteId, date, daysBefore = 0, daysAfter = 0) {
  return fetchMetering(backendFetch, "historical", siteId, date, daysBefore, daysAfter);
}

export async function fetchMeteringForecast(backendFetch, siteId, date, daysBefore = 0, daysAfter = 0) {
  return fetchMetering(backendFetch, "forecast", siteId, date, daysBefore, daysAfter);
}

export async function fetchMeteringActuals(backendFetch, siteId, date, daysBefore = 0, daysAfter = 0) {
  return fetchMetering(backendFetch, "actuals", siteId, date, daysBefore, daysAfter);
}

export async function fetchMeteringPeak(backendFetch, siteId, fromts, tots) {
  const hasPeriod = Number.isFinite(fromts) && Number.isFinite(tots);
  const url =
    config.REACT_APP_HOST +
    "/api/v2/metering/peak/" +
    siteId +
    (hasPeriod ? "?fromts=" + fromts + "&tots=" + tots : "");
  const f = await backendFetch(url);
  const text = await f.text();
  if (!text) return [];
  const raw = JSON.parse(text);
  if (!Array.isArray(raw)) return [];

  return raw
    .filter((row) => row && typeof row === "object")
    .map((row) => ({
      period: row.period,
      naturalpeak: row.naturalpeak,
      drawnpeak: row.drawnpeak,
      accesspower: row.accesspower,
      natural_is_valid: row.natural_is_valid,
      drawn_is_valid: row.drawn_is_valid,
    }));
}

export async function fetchMetering(backendFetch, type, siteId, date, daysBefore = 0, daysAfter = 0) {
  const fromDate = startOfDay(subDays(date, daysBefore));
  const toDate = endOfDay(addDays(date, daysAfter));
  const fromts = Math.round(fromDate.getTime() / 1000);
  const tots = Math.round(toDate.getTime() / 1000);

  const f = await backendFetch(
    config.REACT_APP_HOST + "/api/v2/metering/" + type + "/" + siteId + "?fromts=" + fromts + "&tots=" + tots,
  );
  const text = await f.text();
  if (!text) return null;
  return JSON.parse(text);
}

export async function fetchLiveData(backendFetch, siteId) {
    const f = await backendFetch(config.REACT_APP_HOST + "/api/v2/live/" + siteId)
    return await f.json()

}

export async function fetchImbalancePriceEpex(backendFetch, date, daysBefore = 0, daysAfter = 0) {
    const fromts = Math.round(startOfDay(subDays(date, daysBefore)).getTime() / 1000);
    const tots = Math.round(endOfDay(addDays(date, daysAfter)).getTime() / 1000);
    const f = await backendFetch(config.REACT_APP_HOST + "/api/v2/imbalanceprice-epex?fromts=" + fromts + "&tots=" + tots)
    const text = await f.text();
    if (!text) return null;
    return JSON.parse(text);
}

export async function fetchDeviceMetering(backendFetch, siteId, device_id, device_type, fromts, tots) {
    const f = await backendFetch(config.REACT_APP_HOST + "/api/v2/metering/device/"+siteId+"?device_id=" +device_id + "&device_type=" + device_type + "&fromts=" + fromts + "&tots=" + tots)
    const data = await f.json()
    return data
}


export async function fetchNodeMetering(backendFetch, siteId, node_id, fromts, tots){
    const f = await backendFetch(config.REACT_APP_HOST + "/api/v2/metering/node/"+siteId+"?node_id="+node_id + "&fromts=" + fromts + "&tots=" + tots)
    const data = await f.json()
    return data
}
